<template>
  <div>
    <!-- Form element that submits all the data in the form to Firebase using the submitData method -->
    <form @submit.prevent="$emit('form-submit', form, day)">
      <!-- Add form fields here, wrapped in a div with a class of field -->
      <div class="field">
        <label for="vaginal-bleeding">
          Vaginal bleeding today
        </label>

        <select
          id="vaginal-bleeding"
          name="vaginal-bleeding"
          v-model="form.vaginalBleeding"
          required
        >
          <option
            v-for="(item, index) in this.vaginalBleeding"
            :key="index"
            :value="index"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div class="field">
        <label for="saturation">
          Time to saturate a pad or tampon today
        </label>

        <select
          id="saturation"
          name="saturation"
          v-model="form.saturation"
          required
        >
          <option
            v-for="(item, index) in this.saturation"
            :key="index"
            :value="index"
          >
            {{ item }}
          </option>
        </select>
      </div>

      <div class="field">
        <button class="button button--standard" type="submit">
          <span v-if="day.edit">Update</span>
          <span v-else>Log your bleeding</span>
        </button>
        <button
          class="button button--danger"
          v-if="day.edit"
          @click.prevent="$emit('cancel-edit', day)"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Radios from "@/components/Radios.vue";
import Bleeding from "../../../mixins/modules/bleeding.js";

export default {
  name: "Form",
  mixins: [Bleeding],
  props: ["existingEntry", "day"],
  components: { Radios },

  data() {
    return {
      form: {
        // Add form field data here. This data will be submitted to Firestore and
        // should match the v-model values from your form fields.
        vaginalBleeding: this.existingEntry
          ? this.existingEntry.data.vaginalBleeding
          : 0,
        saturation: this.existingEntry ? this.existingEntry.data.saturation : 0,
      },
    };
  },
};
</script>

<style>
button {
  margin-right: 1rem;
}
</style>
